import React from 'react'

export default function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24" {...props}>
      <rect
        width="8.839"
        height="8.839"
        x="10.099"
        y="5.106"
        fill="var(--svg-color-main, black)"
        opacity="0.4"
        rx="1.15"
        transform="rotate(-23.59 10.1 5.106)"
      ></rect>
      <path
        fill="var(--svg-color-main, black)"
        d="M7.282 4.003A1.841 1.841 0 1 0 5.701.678a1.841 1.841 0 0 0 1.581 3.325M6.962 13.962 4.746 6.858c-.241-.595.068-1.27.675-1.478.683-.232 1.693-.401 2.399-.544.437-.098 1.001.207 1.28.544l3.03 3.19 2.829.386c.891.122 1.54.909 1.488 1.808l-.005.085-4.459-.241a1.27 1.27 0 0 1-.866-.414c-.462-.506-1.26-1.36-1.619-1.625 0 0 2.011 4.507 4.015 8.672l1.444 6.258h-.789a1.92 1.92 0 0 1-1.863-1.47l-1-4.172-1.807-2.983-.635 2.839a1.1 1.1 0 0 1-.12.399L6.27 23.516q-.185-.076-.396-.166c-.955-.402-1.347-1.507-.905-2.444l1.625-3.452z"
      ></path>
    </svg>
  )
}
